export const ADBLOCK_INFO_CLASSNAME = 'pUcHacZ'
